'use client';
import React from 'react';

import { useSession } from '~hooks/useSession';

import { AuthContent } from '../AuthContent';
import { NotAuthContent } from '../NotAuthContent';
import {
	RightContent as StyledRightContent,
	RightContentInner,
} from './styles';

export const RightContent = ({ mini = false }: { mini?: boolean }) => {
	const { isDemoUser, userId } = useSession();

	return (
		<StyledRightContent>
			<RightContentInner>
				{mini || !userId ? null : isDemoUser ? (
					<NotAuthContent />
				) : (
					<AuthContent />
				)}
			</RightContentInner>
		</StyledRightContent>
	);
};
